import React from 'react'
import MarkdownRenderer from './MarkdownRenderer'
import JCMDProcessor from './JCMDProcessor'
import JCMDHistory from './JCMDHistory'

const JCMDTest: React.FC = () => {
  const testContent = `
# JCMD 指令测试

## CREATE 指令测试

### 1. 简单创建Agent
\`\`\`JCMD
CREATE {"name": "测试Agent", "description": "这是一个通过JCMD创建的测试Agent", "type": "conversation"}
\`\`\`

### 2. 完整参数创建Agent
\`\`\`JCMD
CREATE {"name": "智能客服助手", "description": "24/7智能客服系统，自动处理客户咨询", "type": "conversation", "modelId": "gpt-4", "tags": ["客服", "自动化"], "prompt": "你是一个专业的客服助手，请帮助用户解决问题"}
\`\`\`

### 3. 文件转换Agent
\`\`\`JCMD
CREATE {"name": "文档转换器", "description": "智能文档格式转换工具", "type": "file_conversion", "modelId": "claude-3", "tags": ["文档", "转换"]}
\`\`\`

## ALERT 指令测试

\`\`\`JCMD
ALERT {type: "info", title: "测试提示框"}
这是一个测试提示框，用于验证ALERT指令的执行状态。
\`\`\`

## 未知指令测试

\`\`\`JCMD
UNKNOWN {test: "value"}
这是一个未知指令测试，应该显示为不支持状态。
\`\`\`
`

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">JCMD 指令执行状态测试</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* 左侧：Markdown渲染结果 */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Markdown渲染结果：</h2>
          <div className="bg-white border rounded-lg p-4">
            <MarkdownRenderer content={testContent} />
          </div>
        </div>
        
        {/* 右侧：JCMD执行历史 */}
        <div>
          <h2 className="text-lg font-semibold mb-4">JCMD执行历史：</h2>
          <div className="bg-white border rounded-lg p-4">
            <JCMDHistory />
          </div>
        </div>
      </div>
      
      {/* 直接组件测试 */}
      <div className="mt-8">
        <h2 className="text-lg font-semibold mb-4">直接组件测试：</h2>
        <div className="space-y-4">
          <JCMDProcessor 
            command="CREATE" 
            description="创建AI Agent" 
            commandData={`{"name": "直接测试Agent", "description": "通过JCMDProcessor直接创建的测试Agent", "type": "conversation"}`}
          >
            {`{"name": "直接测试Agent", "description": "通过JCMDProcessor直接创建的测试Agent", "type": "conversation"}`}
          </JCMDProcessor>
          
          <JCMDProcessor 
            command="ALERT" 
            description="显示提示框" 
            commandData={`{"type": "success", "title": "直接测试"}`}
          >
            这是一个直接测试的ALERT指令
          </JCMDProcessor>
          
          <JCMDProcessor 
            command="UNKNOWN" 
            description="未知指令" 
            commandData={`{"test": "value"}`}
          >
            这是一个直接测试的未知指令
          </JCMDProcessor>
        </div>
      </div>
    </div>
  )
}

export default JCMDTest 